// extracted by mini-css-extract-plugin
export default {"head":"balance_head__lnJs1","switch":"balance_switch__DyV1k","active":"balance_active__PkZ+L","item":"balance_item__MMwHQ","metamask":"balance_metamask__NONI2"};